module.exports = __webpack_public_path__ + "img/19ddd9a.jpg";